/**
 * Public org-branded landing — /org/<slug>
 *
 * Fetches the org's public profile, renders branded splash, then forwards to
 * the WC invite waiting room with the org's default squad invite code. Slug
 * format is enforced before render to avoid spurious API calls.
 */

import { useMemo } from 'react';
import { useLocalSearchParams, Redirect } from 'expo-router';
import { ErrorBoundary } from '../../components/layout';
import { OrgBrandedLanding } from '../../components/onboarding/OrgBrandedLanding/OrgBrandedLanding';

const ORG_SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{0,62}[a-z0-9])?$/i;

export default function OrgBrandedRoute() {
  const { slug } = useLocalSearchParams<{ slug?: string | string[] }>();
  const normalized = useMemo(() => {
    const raw = Array.isArray(slug) ? slug[0] : slug;
    if (typeof raw !== 'string') return null;
    const trimmed = raw.trim().toLowerCase();
    if (!ORG_SLUG_RE.test(trimmed)) return null;
    return trimmed;
  }, [slug]);

  if (!normalized) {
    return <Redirect href="/" />;
  }

  return (
    <ErrorBoundary>
      <OrgBrandedLanding slug={normalized} />
    </ErrorBoundary>
  );
}
